export const EYEMED_LOGIN = 'EyeMedLogin'
export const OK_BUTTON = 'OK'
